// 2020-06-27export { PrecioCompraVentaComponent } from './precio-compra-venta.component';